import { formatTypingLabel } from "@hooks/presence/presence.lib";
import { getTaskAssigneeDisplayName } from "@components/tasks/task-assignee.lib";
import { UserAvatar } from "@components/avatar/UserAvatar";
import { AvatarGroup } from "@design-system/Avatar/AvatarGroup";
import { HStack } from "@design-system/HStack/HStack";
import { usePresenceUsers } from "./usePresenceUsers";
import styles from "./TypingIndicator.module.scss";

interface TypingIndicatorProps {
    userIds: number[];
}

const MAX_VISIBLE_AVATARS = 3;

export const TypingIndicator = ({ userIds }: TypingIndicatorProps) => {
    const users = usePresenceUsers(userIds);

    const label = formatTypingLabel(users.map(getTaskAssigneeDisplayName));
    if (!label) {
        return null;
    }

    const isSingleTyper = users.length === 1;

    return (
        <HStack
            gap={8}
            align="center"
            className={styles.typingIndicator}
            role="status"
            aria-label={label}
        >
            <AvatarGroup
                items={users}
                getKey={(user) => user.id}
                getLabel={getTaskAssigneeDisplayName}
                renderAvatar={(user) => <UserAvatar user={user} aria-hidden />}
                max={MAX_VISIBLE_AVATARS}
            />
            {isSingleTyper && <span className={styles.label}>{label}</span>}
        </HStack>
    );
};
